import React, { useCallback, useMemo } from "react";

import { Table, TableBody, TableHead, TableHeader, TableRow } from "../../../../components/ui/table";
import { isMobile } from "../../../../handlers/utilityFunctions";
import ApplicationTableRow from "./ApplicationTableRow";
import MobileJobCard from "./MobileJobCard";

function ApplicationsTable({
	jobs,
	openJobDetails,
	handleStatusChange,
	getStatusColor,
	selectedJobs,
	setSelectedJobs,
}) {
	// Calculate select all state
	const allJobIds = useMemo(() => jobs.map((job) => job._id), [jobs]);
	const selectedJobsSet = useMemo(() => new Set(selectedJobs), [selectedJobs]);
	const isAllSelected = allJobIds.length > 0 && allJobIds.every((id) => selectedJobsSet.has(id));
	// Handle select all/none
	useCallback(() => {
		if (isAllSelected) {
			// Deselect all
			setSelectedJobs([]);
		} else {
			// Select all
			setSelectedJobs(allJobIds);
		}
	}, [isAllSelected, allJobIds, setSelectedJobs]);
	// Memoized toggle function for individual rows
	const handleToggleSelection = useCallback(
		(jobId) => {
			setSelectedJobs((prev) => (prev.includes(jobId) ? prev.filter((id) => id !== jobId) : [...prev, jobId]));
		},
		[setSelectedJobs],
	);

	if (isMobile()) {
		return (
			<div className="space-y-3">
				{jobs.map((job) => (
					<MobileJobCard
						key={job._id}
						getStatusColor={getStatusColor}
						handleStatusChange={handleStatusChange}
						openJobDetails={openJobDetails}
						selected={selectedJobsSet.has(job._id)}
						onSelect={() => handleToggleSelection(job._id)}
						handleRowClick={() => handleToggleSelection(job._id)}
						data={job}
					/>
				))}
			</div>
		);
	}

	return (
		<Table>
			<TableHeader>
				<TableRow>
					<TableHead>Position</TableHead>
					{/*<TableHead>Location</TableHead>*/}
					<TableHead>Application Email</TableHead>
					<TableHead>Stage</TableHead>
					<TableHead>Added On</TableHead>
					<TableHead className="text-right">Actions</TableHead>
				</TableRow>
			</TableHeader>
			<TableBody>
				{jobs.map((job) => (
					<ApplicationTableRow
						data={job}
						key={job._id}
						openJobDetails={openJobDetails}
						handleStatusChange={handleStatusChange}
						getStatusColor={getStatusColor}
						selected={selectedJobsSet.has(job._id)}
						onSelect={() => handleToggleSelection(job._id)}
					/>
				))}
			</TableBody>
		</Table>
	);
}

export default ApplicationsTable;
